export default {"src":"/_next/static/media/chart.19da4b40.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};